import React from "react";
import desktop from "../../images/l-desktop.png";

const BannerFullview = () => {
  return (
    <section id="banner_full_view" className="bannerfullview">
      <div className="container">
        <div className="dektop-block">
          <img src={desktop} alt="desktop" />
        </div>
      </div>
    </section>
  );
};

export default BannerFullview;
